/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type UpdateVolunteerShiftsMutationVariables = Types.Exact<{
  where: Types.VolunteerShiftWhereInput;
  data: Types.VolunteerShiftsBulkUpdateInput;
}>;

export type UpdateVolunteerShiftsMutation = {
  updateVolunteerShifts: Array<
    Pick<Types.VolunteerShift, "shift_id" | "registration_open">
  >;
};

export const UpdateVolunteerShiftsDocument = gql`
  mutation UpdateVolunteerShifts(
    $where: VolunteerShiftWhereInput!
    $data: VolunteerShiftsBulkUpdateInput!
  ) {
    updateVolunteerShifts(where: $where, data: $data) {
      shift_id
      registration_open
    }
  }
`;

/**
 * __useUpdateVolunteerShiftsMutation__
 *
 * To run a mutation, you first call `useUpdateVolunteerShiftsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVolunteerShiftsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVolunteerShiftsMutation, { data, loading, error }] = useUpdateVolunteerShiftsMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateVolunteerShiftsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateVolunteerShiftsMutation,
    UpdateVolunteerShiftsMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    UpdateVolunteerShiftsMutation,
    UpdateVolunteerShiftsMutationVariables
  >(UpdateVolunteerShiftsDocument, baseOptions);
}
export type UpdateVolunteerShiftsMutationHookResult = ReturnType<
  typeof useUpdateVolunteerShiftsMutation
>;
export type UpdateVolunteerShiftsMutationResult =
  ApolloReactCommon.MutationResult<UpdateVolunteerShiftsMutation>;
export type UpdateVolunteerShiftsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateVolunteerShiftsMutation,
    UpdateVolunteerShiftsMutationVariables
  >;
